import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  inject,
} from '@angular/core';
import { Match } from '../../../_shared/models/match.model';

import { CommonModule, NgStyle } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ThemeService } from '../../../_core/services/theme.service';

@Component({
  selector: 'app-int-participant',
  templateUrl: './int-participant.component.html',
  styleUrls: ['./int-participant.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgStyle, IonicModule, CommonModule],
})
export class IntParticipantComponent implements OnInit, OnChanges {
  @Input({ required: true }) match: Match;
  @Input({ required: true }) sideNumber: number;
  @Input({ required: true }) serverSideNumber: number;
  @Input({ required: true }) serverPlayerNumber: number;
  @Input({ required: true }) winningSide: number;
  @Input({ required: false }) teamName: string;
  @Input({ required: true }) sideColor: string;
  @Input({ required: true }) teamLogo: string;
  @Input({ required: true }) profileImage: string;
  @Input({ required: true }) setWinner: boolean;
  @Input({ required: false }) summaryView: boolean;

  public themeService = inject(ThemeService); 

  private participantColoredStyle: {
    'background-color': string;
    'font-weight': string;
  };

  private serverColoredStyle: {
    color: string;
    'font-weight': string;
  };

  constructor() {}

  ngOnInit() {
    this.participantColoredStyle = {
      'background-color': this.sideColor,
      'font-weight': 'bold',
    };
  }
  ngOnChanges(change: SimpleChanges) {
    if (change['sideColor']){
        this.serverColoredStyle = {
            color: change['sideColor'].currentValue,
            'font-weight': 'bold',
        };
    }
  }

  getParticipantName(playerNumber: number) {
    const person =
      this.match.sides[this.sideNumber - 1].players[playerNumber - 1]?.participant;
    if (person) {
      return `${person.last_name?.toUpperCase()}, ${person.first_name}`;
    } else {
      if (this.teamName) {
        return `${this.teamName} ${this.match.collectionPosition}`;
      } else {
        return `Player ${this.sideNumber}`;
      }
    }
  }

  getColorStyle(playerNumber: number): {
    'background-color': string;
    'font-weight': string;
  } {
    if (this.winningSide) {
      if (this.winningSide === this.sideNumber) {
        return this.participantColoredStyle;
      }
    } else {
      if (this.serverSideNumber === this.sideNumber) {
        if (this.serverPlayerNumber) {
          if (this.serverPlayerNumber === playerNumber)
            return this.participantColoredStyle;
        } else {
          return this.participantColoredStyle;
        }
      }
    }

    return null;
  }

  getServerStyle(playerNumber: number):{
    color: string;
    'font-weight': string;
  }|null {
    if (this.serverSideNumber === this.sideNumber) {
        if (this.serverPlayerNumber) {
          if (this.serverPlayerNumber === playerNumber)
            return this.serverColoredStyle;
        } else {
          return this.serverColoredStyle;
        }
      }
      return null;
  }
}
